import { useRef, useState } from "react";
import { Paperclip, Send, Mic } from "lucide-react";

export const GlassComposer = ({ onSend, disabled, placeholder, onAttach, attachTitle, testid }) => {
  const [text, setText] = useState("");
  const [listening, setListening] = useState(false);
  const recRef = useRef(null);

  const submit = (e) => {
    e.preventDefault();
    const v = text.trim();
    if (!v || disabled) return;
    onSend(v);
    setText("");
  };

  const toggleMic = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return;
    if (listening) {
      recRef.current?.stop();
      return;
    }
    const rec = new SR();
    rec.lang = "es-DO";
    rec.interimResults = true;
    const base = text ? text + " " : "";
    rec.onresult = (ev) => setText(base + Array.from(ev.results).map((r) => r[0].transcript).join(""));
    rec.onend = () => setListening(false);
    recRef.current = rec;
    rec.start();
    setListening(true);
  };

  return (
    <form onSubmit={submit} className="cai-glass rounded-full h-12 flex items-center pl-4 pr-2 gap-2" data-testid={testid}>
      <button
        type="button"
        onClick={onAttach}
        disabled={!onAttach}
        title={attachTitle}
        data-testid={`${testid}-attach`}
        className="text-white/80 hover:text-white transition-colors disabled:opacity-40"
      >
        <Paperclip className="w-[18px] h-[18px]" strokeWidth={1.6} />
      </button>
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={placeholder}
        data-testid={`${testid}-input`}
        className="cai-input flex-1 min-w-0 text-[13.5px] text-white placeholder:text-white/70"
      />
      <button
        type="submit"
        disabled={disabled || !text.trim()}
        data-testid={`${testid}-send`}
        className="w-8 h-8 grid place-items-center text-white/90 hover:text-white hover:scale-110 transition-transform disabled:opacity-50"
      >
        <Send className="w-[18px] h-[18px]" strokeWidth={1.6} />
      </button>
      <span className="w-px h-5 bg-white/30" />
      <button
        type="button"
        onClick={toggleMic}
        data-testid={`${testid}-mic`}
        title="Dictar"
        className={`w-8 h-8 grid place-items-center rounded-full transition-colors ${
          listening ? "bg-white text-[#6FA2DE]" : "text-white/90 hover:text-white"
        }`}
      >
        <Mic className="w-[18px] h-[18px]" strokeWidth={1.6} />
      </button>
    </form>
  );
};
